import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#checkbox" }),
    /*#__PURE__*/_createTextVNode(" Checkbox ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " A group of options for multiple choices. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIDisabledState = _resolveComponent("EUIDisabledState")
  const _component_EUICheckboxGroup = _resolveComponent("EUICheckboxGroup")
  const _component_EUIIndeterminate = _resolveComponent("EUIIndeterminate")
  const _component_EUIMinMaxItemsChecked = _resolveComponent("EUIMinMaxItemsChecked")
  const _component_EUIButtonStyle = _resolveComponent("EUIButtonStyle")
  const _component_EUIWithBorders = _resolveComponent("EUIWithBorders")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIDisabledState),
    _createVNode(_component_EUICheckboxGroup),
    _createVNode(_component_EUIIndeterminate),
    _createVNode(_component_EUIMinMaxItemsChecked),
    _createVNode(_component_EUIButtonStyle),
    _createVNode(_component_EUIWithBorders)
  ], 64))
}